import React, { useState } from "react";
import { Smartphone, Share, PlusSquare, X, Download } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useInstallPrompt } from "@/hooks/useInstallPrompt";

export const IosInstallDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm" data-testid="install-ios-dialog">
      <DialogHeader><DialogTitle>Add D20 to your Home Screen</DialogTitle><DialogDescription>Safari doesn't show an install button, but it takes two taps:</DialogDescription></DialogHeader>
      <ol className="space-y-3 text-sm">
        <li className="flex items-center gap-3"><span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary"><Share className="h-4 w-4" /></span><span>Tap the <b>Share</b> button at the bottom of Safari.</span></li>
        <li className="flex items-center gap-3"><span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary"><PlusSquare className="h-4 w-4" /></span><span>Choose <b>Add to Home Screen</b>, then <b>Add</b>.</span></li>
      </ol>
      <p className="text-xs text-muted-foreground">D20 opens straight on the Approve screen, full-screen, like an app.</p>
    </DialogContent>
  </Dialog>
);

export const useInstallAction = () => {
  const p = useInstallPrompt();
  const [iosOpen, setIosOpen] = useState(false);
  const run = async () => {
    if (p.native) {
      const outcome = await p.install();
      if (outcome === "accepted") toast.success("D20 installed — find it on your home screen");
    } else setIosOpen(true);
  };
  return { ...p, run, iosDialog: <IosInstallDialog open={iosOpen} onOpenChange={setIosOpen} /> };
};

export const InstallBanner = () => {
  const { canInstall, dismissed, dismiss, run, iosDialog } = useInstallAction();
  if (!canInstall || dismissed) return null;
  return (
    <div className="mb-4 flex items-center gap-3 rounded-xl border border-primary/30 bg-primary/5 px-3 py-2.5 animate-fade-up" data-testid="install-banner">
      {iosDialog}
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground"><Smartphone className="h-5 w-5" /></span>
      <div className="min-w-0 flex-1 text-sm"><div className="font-medium">Add D20 to your home screen</div><div className="text-xs text-muted-foreground">Opens straight on this screen — approve in one tap, no browser bar.</div></div>
      <Button size="sm" onClick={run} data-testid="install-banner-btn"><Download className="mr-1.5 h-3.5 w-3.5" /> Install</Button>
      <button type="button" onClick={dismiss} aria-label="Not now" data-testid="install-banner-dismiss" className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted"><X className="h-4 w-4" /></button>
    </div>
  );
};
